import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerLogoGlowScaleListItem = (props) => {
    const { logoGlowScale, updateVisualizerSettings, maxGlowScale } = props;

    const onScaleChange = (value) => {
        previewHistoryBatch.start();

        updateVisualizerSettings({
            logoGlowSettings: { scale: value }
        });
    };

    return (
        <SliderListItem
            title='Scale'
            value={logoGlowScale}
            displayMultiplier={100 / maxGlowScale}
            min={0}
            max={100}
            step={1}
            onValueChange={onScaleChange}
        />
    );
};

const mapStateToProps = (state) => {
    const logoGlowSettings = state.createPreview.present.videoSettings.visualizer.logoGlowSettings || {};
    const { maxGlowScale } = state.create.maxValues;

    return {
        logoGlowScale: logoGlowSettings.scale ?? 1,
        maxGlowScale
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerLogoGlowScaleListItem);
